import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const GapHorizontalIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "GapHorizontal",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.429 27.429h-2.286c-.63 0-1.143-.514-1.143-1.143V5.714c0-.63.513-1.143 1.143-1.143h2.286a1.142 1.142 0 1 0 0-2.285h-2.286a3.43 3.43 0 0 0-3.429 3.428v20.572a3.43 3.43 0 0 0 3.429 3.428h2.286a1.142 1.142 0 1 0 0-2.286ZM6.857 2.286H4.571a1.142 1.142 0 1 0 0 2.286h2.286c.63 0 1.143.513 1.143 1.142v20.572c0 .63-.513 1.143-1.143 1.143H4.571a1.142 1.142 0 1 0 0 2.286h2.286a3.43 3.43 0 0 0 3.429-3.43V5.716a3.43 3.43 0 0 0-3.429-3.43M16 6.857c-.632 0-1.143.511-1.143 1.143v16a1.142 1.142 0 1 0 2.286 0V8c0-.632-.511-1.143-1.143-1.143"
    })
  }));
};
GapHorizontalIcon.displayName = 'GapHorizontalIcon';